import React, { useState, useEffect } from "react";
import { Link } from "@StarberryUtils";
import { useQuery } from '@apollo/client';
import gql from "graphql-tag"
import Select from 'react-select';
import { node } from "prop-types";
import $ from "jquery";
import { Container } from 'react-bootstrap';
import _ from "lodash"
const GET_TEAM_MENUS = gql`

query TeamMenus {
  peopleCategories(sort: "Sort:asc",where:{Publish:true}) {
    Name
    URL
    people {
      Name
    }
  }
}
`;


function TeamMenus(props, handleClick, data) {

  function filterTeam(event, data) {
    var filtername = event.target.getAttribute('data-filter')
    $('.category-list-team .active').removeClass("active");
    // $('.team-wrap').hide();
    // $('.'+filtername).show();
    props.handlerSelect(filtername)
    $(event.target).addClass("active");
    // if(filtername == 'all') {
    //     $('.team-wrap').show();
    // }

  }


  const [selectedOption, setSelectedOption] = useState({ value: 'all', label: 'All Department' })
  var handleChange = selectedOption => {
    setSelectedOption(selectedOption);
    props.handlerSelect(selectedOption.value)
  };
  useEffect(() => {


  }, []);

  const { loading: newsmenuloading, error: newsmenuerror, data: newsmenu } = useQuery(GET_TEAM_MENUS);
  var options = [{ value: 'all', label: 'All Department' }];
  if (!newsmenuloading) {
    _.forEach(newsmenu.peopleCategories, (area) => {
      options.push({ value: area.URL, label: area.Name })
    })
  }

  if (newsmenuloading) return <p className="gql-loading">Loading ...</p>

  

  return (
    <>

      <ul className="category-list-team d-flex">
        <li className="text-xs">
          <a onClick={filterTeam} data-filter="all" className={props.active + " active"} >All</a>
        </li>
        {newsmenu.peopleCategories.map((node, index) => {
          return (
            <li className="text-xs">
              {node.people.length !== 0 &&
                <a onClick={filterTeam} data-filter={node.URL}>{node.Name}</a>
              }
            </li>
          )
        })}

      </ul>
      <div class="team-filter d-none">
        <Select
          value={selectedOption}
          onChange={handleChange}
          options={options}
          defaultMenuIsOpen={false}
          className={`select-form-control location-filter text-xs`}
          classNamePrefix={`reactSelect2`}
        />
      </div>
    </>
  );
}


export default TeamMenus
